<template>
  <div
    class="text-left text-sm-center w-100 w-sm-75 d-flex flex-column align-items-start align-items-sm-center"
    :class="[
      { 'order-3' : isDesktop },
      { 'order-5' : isMobile },
    ]">
    <span class="font-weight-600 mb-2">Helpfull Tip:</span>
    <span>{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'ScanTips',
  props: {
    message: {
      type: String,
      required: false
    },
  },
  computed: {
    currentBreakpoint() {
      /// Returns current 'morphological' breakpoint value based on window width
      ///
      /// @example
      ///   'xs' | 'sm' | 'md' | 'lg' | 'xl'

      return this.$store.state.config.currentBreakpoint
    },

    isDesktop() {
      return this.currentBreakpoint == 'md' || this.currentBreakpoint == 'lg' || this.currentBreakpoint == 'xl'
    },

    isMobile() {
      return this.currentBreakpoint == 'xs' || this.currentBreakpoint == 'sm'
    },
  }
}
</script>
